var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showDashboard
    ? _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-xl": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", md8: "", "offset-md2": "" } },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: {
                        "background-color": "transparent",
                        color: "basil",
                        grow: ""
                      },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("v-tab", [_vm._v(" Motors ")]),
                      _vm._v(" "),
                      _c("v-tab", [_vm._v(" Motors + Accessories ")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-card",
                            {
                              staticStyle: { float: "left", width: "100%" },
                              attrs: { color: "basil", flat: "" }
                            },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { w4: "", "text-xs-center": "" } },
                                    [
                                      _c("h1", { staticClass: "mb-3 greyy" }, [
                                        _vm._v("WTD")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "circle" }, [
                                        false
                                          ? _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "justify-center": "",
                                                  "align-center": ""
                                                }
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "pinkk",
                                                on: {
                                                  click: function($event) {
                                                    _vm.motorWTDDetailShow = !_vm.motorWTDDetailShow
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "count greyy"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.motorCountWTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "amount" },
                                                  [
                                                    _vm._v(
                                                      " $" +
                                                        _vm._s(
                                                          _vm.motorAmountWTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]),
                                      _vm._v(" "),
                                      _vm.motorWTDDetailShow
                                        ? _c("div", {
                                            staticClass: "details mt-5 greyy",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getmotorDetails(
                                                  _vm.motorsWTD
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { w4: "", "text-xs-center": "" } },
                                    [
                                      _c("h1", { staticClass: "mb-3 greyy" }, [
                                        _vm._v("MTD")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "circle" }, [
                                        false
                                          ? _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "justify-center": "",
                                                  "align-center": ""
                                                }
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "pinkk",
                                                on: {
                                                  click: function($event) {
                                                    _vm.motorMTDDetailShow = !_vm.motorMTDDetailShow
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "count greyy"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.motorCountMTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "amount" },
                                                  [
                                                    _vm._v(
                                                      " $" +
                                                        _vm._s(
                                                          _vm.motorAmountMTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]),
                                      _vm._v(" "),
                                      _vm.motorMTDDetailShow
                                        ? _c("div", {
                                            staticClass: "details mt-5 greyy",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getmotorDetails(
                                                  _vm.motorsMTD
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { w4: "", "text-xs-center": "" } },
                                    [
                                      _c("h1", { staticClass: "mb-3 greyy" }, [
                                        _vm._v("YTD")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "circle" }, [
                                        false
                                          ? _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "justify-center": "",
                                                  "align-center": ""
                                                }
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "pinkk",
                                                on: {
                                                  click: function($event) {
                                                    _vm.motorYTDDetailShow = !_vm.motorYTDDetailShow
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "count greyy"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.motorCountYTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "amount" },
                                                  [
                                                    _vm._v(
                                                      " $" +
                                                        _vm._s(
                                                          _vm.motorAmountYTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]),
                                      _vm._v(" "),
                                      _vm.motorYTDDetailShow
                                        ? _c("div", {
                                            staticClass: "details mt-5 greyy",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getmotorDetails(
                                                  _vm.motorsYTD
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-card",
                            {
                              staticStyle: { float: "left", width: "100%" },
                              attrs: { color: "basil", flat: "" }
                            },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { w4: "", "text-xs-center": "" } },
                                    [
                                      _c("h1", { staticClass: "mb-3 greyy" }, [
                                        _vm._v("WTD")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "circle" }, [
                                        false
                                          ? _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "justify-center": "",
                                                  "align-center": ""
                                                }
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "pinkk",
                                                on: {
                                                  click: function($event) {
                                                    _vm.motorAndAccessoriesWTDDetailShow = !_vm.motorAndAccessoriesWTDDetailShow
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "count greyy"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.motorAndAccessoriesCountWTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "amount" },
                                                  [
                                                    _vm._v(
                                                      " $" +
                                                        _vm._s(
                                                          _vm.motorAndAccessoriesAmountWTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]),
                                      _vm._v(" "),
                                      _vm.motorAndAccessoriesWTDDetailShow
                                        ? _c("div", {
                                            staticClass: "details mt-5 greyy",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getmotorDetails(
                                                  _vm.motorAndAccessoriesWTD
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { w4: "", "text-xs-center": "" } },
                                    [
                                      _c("h1", { staticClass: "mb-3 greyy" }, [
                                        _vm._v("MTD")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "circle" }, [
                                        false
                                          ? _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "justify-center": "",
                                                  "align-center": ""
                                                }
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "pinkk",
                                                on: {
                                                  click: function($event) {
                                                    _vm.motorAndAccessoriesMTDDetailShow = !_vm.motorAndAccessoriesMTDDetailShow
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "count greyy"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.motorAndAccessoriesCountMTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "amount" },
                                                  [
                                                    _vm._v(
                                                      " $" +
                                                        _vm._s(
                                                          _vm.motorAndAccessoriesAmountMTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]),
                                      _vm._v(" "),
                                      _vm.motorAndAccessoriesMTDDetailShow
                                        ? _c("div", {
                                            staticClass: "details mt-5 greyy",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getmotorDetails(
                                                  _vm.motorAndAccessoriesMTD
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { w4: "", "text-xs-center": "" } },
                                    [
                                      _c("h1", { staticClass: "mb-3 greyy" }, [
                                        _vm._v("YTD")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "circle" }, [
                                        false
                                          ? _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "justify-center": "",
                                                  "align-center": ""
                                                }
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "pinkk",
                                                on: {
                                                  click: function($event) {
                                                    _vm.motorAndAccessoriesYTDDetailShow = !_vm.motorAndAccessoriesYTDDetailShow
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "count greyy"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.motorAndAccessoriesCountYTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "amount" },
                                                  [
                                                    _vm._v(
                                                      " $" +
                                                        _vm._s(
                                                          _vm.motorAndAccessoriesAmountYTD
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]),
                                      _vm._v(" "),
                                      _vm.motorAndAccessoriesYTDDetailShow
                                        ? _c("div", {
                                            staticClass: "details mt-5 greyy",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getmotorDetails(
                                                  _vm.motorAndAccessoriesYTD
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f670a3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f670a3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MotorisationDashboard.vue
// module id = null
// module chunks = 